import React, { useState, useEffect } from "react";
import { Container, Col, Row, Card, CardBody, Table, Button } from "reactstrap";
import { Link } from "react-router-dom";
// Import rank images
import firstPlaceImg from "../../assets/images/items/1st.png";
import secondPlaceImg from "../../assets/images/items/2nd.png";
import thirdPlaceImg from "../../assets/images/items/3rd.png";

// Import item images (for the top-three description)
import pokeBallImg from "../../assets/images/items/pokeball.png";
import coinImg from "../../assets/images/items/coin.png";
import api from "../../api";

// Helper function to format a number with commas
function formatNumber(num) {
  return num.toLocaleString();
}

const CatchRankings = () => {
  // Page state
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [total, setTotal] = useState(0);

  // Data state for current page rankings
  const [catchers, setCatchers] = useState([]);

  // Data state for top three players (for description)
  const [topThree, setTopThree] = useState([]);

  // Loading and error state
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  document.title = "Catcher Rankings";

  // Fetch leaderboard data for the current page
  useEffect(() => {
    const fetchLeaderboard = async () => {
      setIsLoading(true);
      setError("");
      try {
        const response = await api.get(
          `/v1/catch-rankings?page=${page}&limit=${limit}`,
          { withCredentials: true },
        );
        // Adjust based on your backend response structure
        const data = response.data.data;
        const totalCount = response.data.total || 0;
        setCatchers(data);
        setTotal(totalCount);
      } catch (err) {
        console.error(err);
        setError("Failed to load catch leaderboard");
      } finally {
        setIsLoading(false);
      }
    };

    fetchLeaderboard();
  }, [page, limit]);

  // Fetch top three players for the top description
  useEffect(() => {
    const fetchTopThree = async () => {
      try {
        const response = await api.get("/v1/catch-rankings?page=1&limit=3", {
          withCredentials: true,
        });
        const data = response.data.data;
        setTopThree(data);
      } catch (err) {
        console.error("Failed to fetch top three catchers", err);
      }
    };
    fetchTopThree();
  }, []);

  // Calculate total pages
  const totalPages = Math.ceil(total / limit);

  const handlePrev = () => {
    if (page > 1) {
      setPage((prev) => prev - 1);
    }
  };

  const handleNext = () => {
    if (page < totalPages) {
      setPage((prev) => prev + 1);
    }
  };

  // Build the top description with item images

  // Helper: Get rank image based on rank number (for top 3 rows)
  const getRankImage = (rank) => {
    if (rank === 1) return firstPlaceImg;
    if (rank === 2) return secondPlaceImg;
    if (rank === 3) return thirdPlaceImg;
    return null;
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col md={12}>
              <Card>
                <CardBody>
                  <h4 className="mb-4">Catcher Rankings</h4>

  

                  {isLoading && <div>Loading leaderboard...</div>}
                  {error && <div className="text-danger">{error}</div>}

                  {!isLoading && !error && (
                    <div>
                      <Table striped responsive className="align-middle">
                        <thead>
                          <tr>
                            <th style={{ width: "5%" }}>Rank</th>
                            <th style={{ width: "10%" }}>Avatar</th>
                            <th>Username</th>
                            <th>Catcher Experience</th>
                          </tr>
                        </thead>
                        <tbody>
                          {catchers.map((catcher, index) => {
                            const rank = (page - 1) * limit + (index + 1);
                            return (
                              <tr key={catcher.username}>
                                <td>
                                  {rank <= 3 ? (
                                    <img
                                      src={getRankImage(rank)}
                                      alt={`${rank} rank`}
                                    />
                                  ) : (
                                    rank
                                  )}
                                </td>
                                <td>
                                  <img
                                    src={`/avatars/${catcher.avatar}.png`}
                                    alt="avatar"
                                    style={{
                                      width: 40,
                                      height: 40,
                                      borderRadius: "50%",
                                    }}
                                  />
                                </td>
                                <td>
                                  <Link
                                    to={`/playerprofile?user=${catcher.username}`}
                                    style={{
                                      textDecoration: "none",
                                      color: "white",
                                    }}
                                  >
                                    {catcher.username}
                                  </Link>
                                </td>
                                <td  style={{
                                      textDecoration: "none",
                                      color: "white",
                                    }}>{formatNumber(catcher.catcher_exp)}</td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </Table>

                      {/* Pagination Controls */}
                      <div className="d-flex justify-content-between align-items-center mt-3">
                        <div>
                          <Button
                            color="primary"
                            disabled={page <= 1}
                            onClick={handlePrev}
                          >
                            Prev
                          </Button>{" "}
                          <Button
                            color="primary"
                            disabled={page >= totalPages}
                            onClick={handleNext}
                          >
                            Next
                          </Button>
                        </div>
                        <div>
                          Page {page} of {totalPages || 1}
                        </div>
                      </div>
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default CatchRankings;
